export const Svg_098 = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={70}
    height={70}
    fill="none"
  >
    <path
      fill="url(#a)"
      d="M5.834 55.344V50.97c1.701-.194 3.074-.717 4.12-1.568 1.045-.85 2.734-1.276 5.067-1.276 2.48 0 4.327.474 5.542 1.422 1.215.948 2.698 1.422 4.448 1.422 1.798 0 3.33-.474 4.594-1.422 1.264-.948 3.062-1.422 5.395-1.422 2.48 0 4.315.474 5.506 1.422 1.19.948 2.71 1.422 4.557 1.422 1.701 0 3.16-.474 4.375-1.422 1.215-.948 3.062-1.422 5.542-1.422 2.333 0 4.022.426 5.067 1.276 1.045.851 2.419 1.374 4.12 1.568v4.375c-1.896 0-3.524-.474-4.885-1.422-1.361-.948-2.82-1.422-4.375-1.422-1.799 0-3.306.474-4.521 1.422-1.216.948-3.014 1.422-5.396 1.422-2.43 0-4.241-.474-5.432-1.422-1.191-.948-2.71-1.422-4.558-1.422-1.798 0-3.293.474-4.484 1.422-1.19.948-3.002 1.422-5.432 1.422-2.43 0-4.242-.474-5.433-1.422-1.19-.948-2.71-1.422-4.557-1.422-1.555 0-2.99.474-4.302 1.422-1.312.948-2.965 1.422-4.958 1.422ZM16.77 43.75a8.17 8.17 0 0 1-3.062-.583 7.77 7.77 0 0 1-2.625-1.75l-3.5-3.5 3.062-3.062 3.5 3.427c.39.389.802.668 1.24.838.437.17.9.255 1.385.255h4.375V25.813l-4.448 3.208-2.552-3.5L35 10.21 55.855 25.52l-2.552 3.573-4.448-3.281v13.562h4.375c.534 0 1.008-.085 1.422-.255.413-.17.814-.45 1.203-.838l3.5-3.427 3.062 3.062-3.5 3.5a7.77 7.77 0 0 1-2.625 1.75 8.17 8.17 0 0 1-3.062.583H16.77Zm8.75-4.375h7.292v-5.833h4.375v5.833h7.292v-16.77L35 15.677l-9.479 6.928v16.77Z"
    />
    <defs>
      <linearGradient
        id="a"
        x1={19.323}
        x2={37.981}
        y1={16.979}
        y2={56.004}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
    </defs>
  </svg>
)